import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { JOBS, MARITAL_STATUS } from "./options";
import useJwt from '@src/auth/jwt/useJwt'

export const listDepartments = createAsyncThunk('departments/GET', async (params = {}, {dispatch}) => {
  const departamentos = (await dispatch(getAllDeparments())).payload
  for (const department of departamentos) {
    const municipios = (await dispatch(getMunicipalityByCodeDepartment(department?.code))).payload
    department.municipios = municipios
  }

  return departamentos
  // return departments
})

export const getAllDeparments = createAsyncThunk('GET/allDepartments', async () => {
  const params = { category: 'employee', method: 'departamentos' }
  const response = await useJwt.getData(params)
  const departamentos = response.data.map(departamento => ({label: departamento?.nombre, value: departamento.nombre, code: departamento?.COD}))
  return departamentos
})

export const getMunicipalityByCodeDepartment = createAsyncThunk('GET/municipality', async (departmentCode) => {
  const response = await useJwt.catalogMunicipios(departmentCode)
  const municipios = response.data.map((municipio) => ({label: municipio?.DES, value: municipio?.DES , code: municipio?.COD}))
  return municipios
})

export const getCatalogRelationsShip = createAsyncThunk('GET/getCatalogRelationsShip', async (params) => {
  const response = await useJwt.getData(params)
  const catalogParentezco = response.data.map(r => ({label: r?.DES, value: r?.DES}))
  return catalogParentezco
})

export const getCatalogFamilyState = createAsyncThunk('GET/getCatalogFamilyState', async () => {
  const response = await useJwt.getData({ category: 'employee', method: 'catalog-soa-civil-status' })
  // console.log('catalog-soa-civil-status', response.data)

  const catalogFamilyState = response.data.reduce((acc, item) => {
    const key = item.COD
    const value = item.COD
    const label = item.DES
    acc[key] = { value, label, key }
    return acc
  }, {})

  // console.log('catalogFamilyState', catalogFamilyState)
  return catalogFamilyState
})

export const appGlobalConfig = createSlice({
  name: 'globalconfig',
  initialState: {
    departments: [],
    FAMILY_STATE: {},
    jobs: JOBS,
    familystatus: MARITAL_STATUS,
    nationality: [{ value: 'El Salvador', label: 'El Salvador' }],
    relationsShip: [],
  },
  extraReducers: build => build
  .addCase(getCatalogRelationsShip.fulfilled, (state, action) => {
    state.relationsShip = action.payload
  })
  .addCase(listDepartments.fulfilled, (state, action) => {
    state.departments = action.payload
  })
  .addCase(getCatalogFamilyState.fulfilled, (state, action) => {
    state.FAMILY_STATE = action.payload
  })
}
)

export default appGlobalConfig.reducer